import { EAction } from '~/src/features/tariffBuilder/constants/actions';
import { IAction } from '~/src/store';

type TSetAgreementData = {
    agreementId: string | number | null,
    agreementNumber: string | number | null,
    isDouble?: boolean,
    hasError?: boolean,
    errorMessage?: string,
}

const setAgreementData = (data: Partial<TSetAgreementData>): IAction<EAction.SetAgreementData> => ({
    type: EAction.SetAgreementData,
    payload: data,
});

export default setAgreementData;
